const theme = {
  hover: {
    opacity: 0.7,
  },
  border: {
    radius: "8px",
    width: "1px",
    style: "solid",
  },
  header: {
    height: 72,
  },
  footer: {
    desktop: {
      height: 52,
    },
    mobile: {
      height: 104,
    },
  },
};

export default theme;
